import APIService from '../api';
import axios from 'axios';
import Vue from 'vue';
import VueAxios from 'vue-axios';

class OffersService extends APIService {
  constructor() {
    Vue.use(VueAxios, axios);
    super();
  }

  get resource() {
    return `/admin/offer`;
  }

  getAllActiveOffers(
    params: Record<string, any> = {
      status: 'active',
      limit: '1000'
    }
  ) {
    return this.get(this.resource, { params });
  }

  getOffers(
    sortField: string = '',
    sortOrder: string = '',
    pagination: string = '',
    filters: string
  ) {
    const resource = this.generateResource(
      `${this.resource}?`,
      sortField,
      sortOrder,
      pagination,
      filters,
      true,
      '&type=General'
    );

    return this.get(resource);
  }

  getBirthdayOffers(
    sortField: string = '',
    sortOrder: string = '',
    pagination: string = '',
    filters: string
  ) {
    const resource = this.generateResource(
      `${this.resource}?`,
      sortField,
      sortOrder,
      pagination,
      filters,
      true,
      '&type=Birthday'
    );

    return this.get(resource);
  }

  getOfferByTitle(name: string) {
    const url = `${this.resource}?&title=${name}`;
    return this.get(url);
  }

  getOfferById(offerId: string) {
    const url = `${this.resource}/${offerId}`;
    return this.get(url);
  }

  newOffer(data: any) {
    return this.post(this.resource, data);
  }

  changeOfferStatus(id: string, status: string) {
    return this.put(`${this.resource}/${id}/status`, { status });
  }

  updateOffer(offerId: string, data: { imageId: string; setActive?: boolean }) {
    return this.put(`/admin/special-offer/${offerId}`, data);
  }

  sendOffer(offerId: string, data: object) {
    return this.put(`${this.resource}/${offerId}/send-to-customers`, data);
  }
}

export default OffersService;
